import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import AdminRoutes from "./Routes/AdminRoutes";
import FontRoutes from "./Routes/FontRoutes";
import ScrollToTop from "./Font/components/ScrollToTop";
import ProtectedRoute from "./Routes/ProtectedRoute";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>

        {/* ADMIN ROUTES */}
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute>
              <AdminRoutes />
            </ProtectedRoute>
          }
        />

        {/* FRONT WEBSITE ROUTES */}
        <Route path="/*" element={<FontRoutes />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;